<template>
  <modal-template v-if="openModalError"
                  size="small"
                  @close="$root.$emit('closeModalError')">
    <b-row>
      <b-col cols="12">
        <b-img-lazy :src="require('@/assets/images/ic-sad.png')"
                    alt="Modal error"
                    fluid />
      </b-col>
      <b-col cols="12"
             class="mB15">
        <h2 v-if="details.text"
            v-html="details.text" />
        <h2 v-if="details.textI18N"
            v-html="$t(details.textI18N)" />
      </b-col>
    </b-row>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  data() {
    return {
      details: {},
      openModalError: false
    }
  },
  created() {
    this.$root.$on('closeModalError', () => {
      this.openModalError = false
    })
    window.addEventListener(
      'showError',
      e => {
        this.openModalError = true
        this.details = e.detail
      },
      false
    )
  }
}
</script>
